// sp_Slider
function spitem() {
  var $slider = $('.item-slider');

  // 要素が無いページでは何もしない
  if (!$slider.length) return;

  if (window.innerWidth <= 768) {
    // スマホ用
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        fade: true,
        arrows: false
      });
    }
  } else {
    // PC用（slick解除）
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

// リサイズ時（reloadは不要・削除）
$(window).on('resize', function () {
  spitem();
});

// 初回実行（DOM ready 後）
$(function () {
  spitem();
});
